<div>
    <div class="container">
      <div *ngIf="!contentNotFound" class="col-xs-12 generic-content-container">
        <div class="title-text">
          <h1 class="title-text"><adp-label [labelKey]="titleKey"></adp-label></h1>
        </div>
        <div class="body-text">
          <adp-label [labelKey]="bodyKey"></adp-label>
        </div>
      </div>
      <div *ngIf="contentNotFound" class="col-xs-12 generic-content-container">
        <div class="title-text">
          <h1 class="title-text"><adp-label labelKey="GenericContent_Default_Title"></adp-label></h1>
        </div>
        <div class="body-text text-center">
          <adp-label labelKey="GenericContent_Default_Body"></adp-label>
        </div>
      </div>
    </div>
</div>
